import axios from 'axios';

let interceptorConfigured = false;
const JWT_STORAGE_KEY = 'cobros.jwt';

export function getJwtFromSearch(search = "") {
  try {
    return new URLSearchParams(search).get('jwt') || "";
  } catch (error) {
    return "";
  }
}

export function resolveJwt(search = "") {
  const jwtFromSearch = getJwtFromSearch(search);

  if (jwtFromSearch) {
    try {
      window.sessionStorage.setItem(JWT_STORAGE_KEY, jwtFromSearch);
    } catch (error) {
      // El navegador puede bloquear el almacenamiento; el JWT de la URL
      // igualmente se utiliza para la solicitud actual.
    }

    return jwtFromSearch;
  }

  try {
    return window.sessionStorage.getItem(JWT_STORAGE_KEY) || "";
  } catch (error) {
    return "";
  }
}

export function setupAxiosAuth() {
  if (interceptorConfigured) {
    return;
  }

  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    const nextConfig = { ...config };
    const jwt = resolveJwt(window.location.search);

    nextConfig.withCredentials = nextConfig.withCredentials ?? true;

    if (jwt) {
      const headers = { ...(nextConfig.headers || {}) };
      const currentAuthHeader = headers.Authorization || headers.authorization;

      if (!currentAuthHeader || String(currentAuthHeader).trim() === '' || String(currentAuthHeader).trim() === 'Bearer') {
        headers.Authorization = `Bearer ${jwt}`;
      }

      nextConfig.headers = headers;
    }

    return nextConfig;
  });

  interceptorConfigured = true;
}
